<template>
  <div class="col-12 col-md-12 col-lg-12 col-xl-12 px-1">
    <div class="card card-avatar">
      <div class="card-body pb-2">
        <div
          class="profile row col-sm-12 col-12 px-0 mx-0 pb-2"
          :class="[
            arr === 'row' ? 'profile-mobile-row' : 'profile-mobile-column ',
            showBtn === true ? '' : 'border-bottom-0',
          ]"
        >
          <!-- 頭像 -->
          <div
            class="profile-img col-12 col-sm-12 d-flex justify-content-enter mx-0 px-0"
          >
            <div
              class="mx-auto img-avatar img-avatar-frame"
              @click="$goPage(`/msu/my-title`)"
            >
              <img
                v-if="user.student.image !== undefined"
                :src="
                  $getAvatar(user.student.image, false, user.student.titlelv)
                "
                class="rounded-circle"
                alt="profile-image"
              />
            </div>
          </div>
          <h4 class="text-capitalize mb-0 col-12 col-sm-12 text-center">
            <div
              v-if="user.student.firstName === undefined"
              class="m-text msu-semibold"
            >
              {{ user.student.studentName }}
            </div>
            <div v-else class="m-text msu-semibold">
              {{ user.student.firseName }} {{ user.student.lastName }}
            </div>
          </h4>
          <div
            class="mb-0 col-12 col-sm-12 text-center s-text msu-semibold"
            style="color: #ff5c75"
          >
            {{ user.student.title }}
          </div>
          <div
            class="mb-0 col-12 col-sm-12 text-center s-text msu-semibold"
            style="color: #545454"
          >
            English Level: {{ user.student.plcmt_lvl }}
          </div>
          <!-- 姓名等級稱號 -->
          <div
            class="profile-text d-flex justify-content-center align-items-center col-12 col-sm-12 px-0 my-auto p-2"
          >
            <div
              class="col-12 col-sm-12 d-flex align-items-center justify-content-center px-1"
              style="min-height: 100%; height: 80px"
            >
              <div
                style="max-width: 100%"
                class="d-flex align-items-start justify-content-center"
              >
                <img
                  :src="getLVImg(user.student.level)"
                  alt=""
                  style="max-width: 100%; width: 58px"
                />
              </div>
              <div
                style="min-height: 100%"
                class="mx-1 col-9 col-sm-9 pt-2 px-1"
              >
                <div
                  class="text-left d-flex justify-content-between"
                  style="font-size: 16px"
                >
                  <span class="text-left s-text msu-semibold msu-dark"
                    >{{ $t("lv") }} {{ user.student.level }}</span
                  >
                  <div>
                    <img
                      v-if="shouldShowGachaIcon"
                      :src="img_diamond"
                      alt=""
                      class="ml-1 cursor-pointer"
                      @click="gotoGacha()"
                    />
                    <span
                      v-if="shouldShowGachaIcon"
                      class="ml-1 s-text msu-semibold"
                      >{{ gachaChances }}</span
                    >
                  </div>
                </div>
                <!-- red box -->
                <div class="exp-box px-0 pt-1 pb-0">
                  <div
                    class="progress progress-active-sessions mb-1"
                    style="height: 7px"
                  >
                    <div
                      class="progress-bar progress-bar-user"
                      role="progressbar"
                      :style="{
                        width: tempExp + `%`,
                      }"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div class="row d-flex justify-content-between">
                    <div
                      class="text-left msu-dark col-12 col-sm-12 text-dark s-text msu-semibold"
                    >
                      {{ $t("exp") }}

                      <span class="ml-1">{{ user.student.exp }}</span>
                      /
                      <span class="">{{ user.student.amt_exp }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
            <!-- </div> -->
          </div>
          <i
            class="fa-solid fa-caret-down"
            @click="showMore = true"
            v-if="
              (deviceType === 'mobile' ||
                deviceType === 'tablet' ||
                deviceType === 'ipad' ||
                windowWidth < 992) &&
              showMore === false
            "
          ></i>
          <i
            class="fa-solid fa-caret-up"
            @click="showMore = false"
            v-if="showMore === true"
          ></i>
        </div>

        <div v-if="showBtn && userCustomization.userGroup !== 'B2C'">
          <!-- 圓按鈕 僅網頁顯示 -->
          <div class="d-none d-lg-block">
            <div class="row col-12 px-0 mx-0 my-3">
              <div
                v-for="item in btnItem"
                :key="item.title"
                class="col-12 col-sm-6 col-md-3 pa-1"
                @click="$goPage(item.link)"
              >
                <div class="position-relative">
                  <img
                    :src="getButtonImage(item.imageType)"
                    class="img-fluid activity-btn-img"
                  />
                  <span
                    v-if="item.hint !== 0 && item.hint !== ''"
                    class="hint badge badge-danger rounded-circle p-0 font-size-12 font-weight-bold position-absolute"
                    style="top: 5px; right: 5px"
                    >{{ item.hint }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- END 圓按鈕 僅網頁顯示 -->
          <!-- 活動圖片區域 -->
          <div class="d-none d-lg-block">
            <!-- English 活動 -->
            <div v-if="shouldShowEnglishActivities" class="my-3">
              <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
                {{ $t("English") }}
              </h6>
              <div class="row col-12 px-0 mx-0 my-3">
                <div
                  v-for="i in isAppDomain ? 5 : 4"
                  :key="`english-${i}`"
                  class="col-12 col-sm-6 col-md-3 pa-1 mb-3"
                  @click="goExternalLink(i, 'english')"
                >
                  <img
                    :src="getActivityImage(i, 'english')"
                    class="img-fluid activity-btn-img"
                  />
                </div>
              </div>
            </div>
            <!-- Relax 活動 -->
            <div v-if="shouldShowRelaxActivities" class="">
              <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
                {{ $t("Relax") }}
              </h6>
              <div class="row col-12 px-0 mx-0 justify-content-start">
                <div
                  v-for="i in [2, 3]"
                  :key="`relax-${i}`"
                  class="col-12 col-sm-6 col-md-3 pa-1"
                  @click="goExternalLink(i, 'relax')"
                >
                  <img
                    :src="getActivityImage(i, 'relax')"
                    class="img-fluid activity-btn-img"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- HomeActivity card -->
          <div class="d-none d-lg-block">
            <div
              class="gift-wrap2 my-3 mx-0 px-3 py-3 pointer"
              v-for="ac in activityList"
              @click="openActivity(ac)"
            >
              <div
                class="px-0 gift-text m-text msu-semibold2 align-middle d-flex col-12 col-sm-12 justify-content-center"
              >
                <div
                  class="font-weight-bold col-12 col-sm-12 d-flex justify-content-center m-text msu-semibold text-white align-items-center"
                >
                  <i class="fa-solid mr-1 text-white" :class="ac.icon"></i
                  >{{ ac.key }}
                </div>
                <div class="ml-auto font-weight-bold">
                  <i class="fa-solid fa-chevron-right text-white"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- END HomeActivity card -->
        </div>
      </div>
      <!--END 名片 -->
      <!-- 圓按鈕 平板以下顯示 -->
      <div
        v-if="showBtn && showMore && userCustomization.userGroup !== 'B2C'"
        class="row d-lg-none"
      >
        <div class="col-12">
          <div class="row col-12 col-sm-12 col-md-12 px-2 mx-0">
            <div
              v-for="item in btnItem"
              :key="item.title"
              class="col-6 col-sm-6 col-md-3 py-2"
              @click="$goPage(item.link)"
            >
              <div class="position-relative">
                <img
                  :src="getButtonImage(item.imageType)"
                  class="rounded img-fluid activity-btn-img"
                />
                <span
                  v-if="item.hint !== 0 && item.hint !== ''"
                  class="hint badge badge-danger rounded-circle p-0 font-size-12 font-weight-bold position-absolute"
                  style="top: 5px; right: 5px"
                  >{{ item.hint }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <!-- 活動圖片區域 - 移動設備 -->
      <div
        v-if="showBtn && showMore && userCustomization.userGroup !== 'B2C'"
        class="px-3 d-lg-none"
      >
        <!-- English 活動 -->
        <div v-if="shouldShowEnglishActivities" class="my-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("English") }}
          </h6>
          <div class="row col-12 px-0 mx-0">
            <div
              v-for="i in isAppDomain ? 5 : 4"
              :key="`mobile-english-${i}`"
              class="col-6 col-sm-6 col-md-3 pa-1 mb-3"
              @click="goExternalLink(i, 'english')"
            >
              <img
                :src="getActivityImage(i, 'english')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>
        <!-- Relax 活動 -->
        <div v-if="shouldShowRelaxActivities" class="my-3">
          <h6 class="pl-3 text-left mb-2 msu-semibold activity-title-color">
            {{ $t("Relax") }}
          </h6>
          <div class="row col-12 px-0 mx-0 justify-content-center">
            <div
              v-for="i in [2, 3]"
              :key="`mobile-relax-${i}`"
              class="col-6 col-sm-6 col-md-3 pa-1"
              @click="goExternalLink(i, 'relax')"
            >
              <img
                :src="getActivityImage(i, 'relax')"
                class="img-fluid activity-btn-img"
              />
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useUserInfoStore } from "@/store/modules/userInfo";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
import { useI18n } from "vue-i18n";
import { ApiPrize } from "@/service/apis/prize";
const { locale, t } = useI18n({
  inheritLocale: true,
});
const user = useUserInfoStore();
const userCustomization = useUserCustomizationStore();
const $goPage = inject("$goPage");
const $getAvatar = inject("$getAvatar");
const showMore = ref(false);
const getDetectObj = () => {
  // console.log("get user device");
  // window.location.reload();
  const ua = navigator.userAgent;

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};
const props = defineProps({
  arr: String,
  showBtn: Boolean,
});

const img_lv1_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv1.png`, import.meta.url).href;
});

const img_lv2_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv2.png`, import.meta.url).href;
});

const img_lv3_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv3.png`, import.meta.url).href;
});

const img_lv4_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv4.png`, import.meta.url).href;
});

const img_lv5_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv5.png`, import.meta.url).href;
});

const img_lv6_logo = computed(() => {
  return new URL(`../assets/img/icon/Group_lv6.png`, import.meta.url).href;
});

const img_diamond = computed(() => {
  return new URL(`../assets/img/icon/msu_token.png`, import.meta.url).href;
});

// 參照HomeActivityModal的方式，創建動態圖片獲取函數
const getButtonImage = (buttonType) => {
  return new URL(
    `../assets/img/activity_icon/functionimg/${buttonType}.png`,
    import.meta.url
  ).href;
};

// 添加活動圖片獲取函數（來自HomeActivityModal）
const getActivityImage = (index, activityType) => {
  if (activityType === "english") {
    return new URL(`../assets/img/activity_icon/e${index}.png`, import.meta.url)
      .href;
  } else if (activityType === "relax") {
    return new URL(
      `../assets/img/activity_icon/game${index}.png`,
      import.meta.url
    ).href;
  }
};

// 使用客製化配置的按鈕項目
const btnItem = computed(() => {
  return userCustomization.filteredUserCardBtnItems.map((item) => ({
    ...item,
    title: t(item.title),
    hint: item.hint === "totalReward" ? user.hint.totalReward : item.hint,
  }));
});

// 使用客製化配置的活動區域
const userCardActivities = computed(() => {
  return userCustomization.userCardActivities;
});

// 檢查是否應該顯示 English 活動
const shouldShowEnglishActivities = computed(() => {
  return userCardActivities.value.english.visible;
});

// 檢查是否應該顯示 Relax 活動
const shouldShowRelaxActivities = computed(() => {
  return userCardActivities.value.relax.visible;
});

// 檢查 VITE_MSU_DOMAIN 環境變數是否為 'app'
const isAppDomain = computed(() => {
  return (
    import.meta.env.VITE_MSU_DOMAIN === "app" ||
    import.meta.env.VITE_MSU_DOMAIN === "mm"
  );
});

// 添加外部連結跳轉函數（來自HomeActivityModal）
const goExternalLink = (index, activityType) => {
  const currentLang = locale.value;
  if (activityType === "english") {
    if (index === 1) {
      $goPage(`/msu/phrasal-verb?LANG=${currentLang}`);
    } else if (index === 2) {
      $goPage(`/msu/daily-conversation?LANG=${currentLang}`);
    } else if (index === 4) {
      let token = localStorage.getItem("token");
      let link = `https://ai-edu.mangosteems.com/ai_speak/?lang=${currentLang}&auth=${token}?userid=${user.student.stuID}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      $goPage(`/msu/practice-words`);
    } else if (index === 5) {
      $goPage(`/msu/english-central`);
    }
  } else if (activityType === "relax") {
    if (index === 1) {
      // 處理 index 1 的情況
    } else if (index === 2) {
      let token = localStorage.getItem("token");
      let link = `https://whacamole.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      let token = localStorage.getItem("token");
      let link = `https://cardgame.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    }
  }
};

const tempExp = ref(0);
const interval = ref(null);
const progressBar = (exp, total) => {
  let expBar = (Number(exp) / total) * 100;
  // console.log(expBar);
  // console.log(tempExp.value);
  if (interval.value === null) {
    interval.value = setInterval(() => {
      tempExp.value = tempExp.value + 0.5;
      progressBar(exp, total);
    }, 5);
  } else if (tempExp.value > expBar) {
    clearInterval(interval.value);
  }
};

const activityList = ref([]);
const getActivity = async () => {
  const currentLang = locale.value;
  activityList.value.push({
    key: t("English"),
    name: "English",
    value: "english",
    link: `#`,
    icon: "fa-comments",
    lang: currentLang,
  });
  activityList.value.push({
    key: t("Relax"),
    name: "Relax",
    value: "relax",
    link: `#`,
    icon: "fa-gamepad",
    lang: currentLang,
  });
  // let result = await ApiGetHomeActivity.get();
  // console.log("====================");
  // console.log(result);

  // activityList.value.push({
  //   key: t("Phrasal"),
  //   name: "Phrasal",
  //   link: `inside`,
  // });
  // activityList.value.push({
  //   key: t("mini-game"),
  //   name: "Mini Game",
  //   link: `https://cardgame.mangosteems.com/?auth=${localStorage.getItem(
  //     "token"
  //   )}&lmsd=${import.meta.env.VITE_MSU_DOMAIN}`,
  // });

  // activityList.value.push({
  //   key: t("daily-conversation"),
  //   name: "Conversation",
  //   link: `inside`,
  // });

  // activityList.value.push({
  //   key: t("whac-a-mole"),
  //   name: "Whac a Mole",
  //   link: `https://whacamole.mangosteems.com/?auth=${localStorage.getItem(
  //     "token"
  //   )}`,
  // });
};
const gotoGacha = () => {
  $goPage(`/msu/gacha`);
};
const getLVImg = (lv) => {
  let Numlv = Number(lv);
  // console.log(typeof Numlv);
  if (Numlv >= 0 && Numlv <= 15) {
    return img_lv1_logo.value;
  } else if (Numlv >= 16 && Numlv <= 30) {
    return img_lv2_logo.value;
  } else if (Numlv >= 31 && Numlv <= 45) {
    return img_lv3_logo.value;
  } else if (Numlv >= 46 && Numlv <= 60) {
    return img_lv4_logo.value;
  } else if (Numlv >= 61 && Numlv <= 75) {
    return img_lv5_logo.value;
  } else if (Numlv >= 76 && Numlv <= 100) {
    return img_lv6_logo.value;
  } else {
    return img_lv1_logo.value;
  }
};
const checkDeviceType = computed(() => {
  const screenWidth = window.innerWidth;

  // 使用媒體查詢進行判斷
  if (screenWidth < 768) {
    // 手機裝置
    // 執行相應的邏輯或設置狀態
    return "mobile";
  } else if (screenWidth >= 768 && screenWidth < 1024) {
    // 平板裝置
    // 執行相應的邏輯或設置狀態
    return "tablet";
  } else {
    // 桌面裝置
    // 執行相應的邏輯或設置狀態
    return "desktop";
  }
});
const deviceType = ref("");
const windowWidth = ref(window?.innerWidth || 0);

// 添加一个响应式变量来存储抽奖次数
const gachaChances = ref(0);

// 添加計算屬性來檢查是否應該顯示扭蛋圖標
const shouldShowGachaIcon = computed(() => {
  const domain = import.meta.env.VITE_MSU_DOMAIN;
  console.log("domain", domain);
  return domain === "app" || domain === "pts";
});

// 获取抽奖次数的函数
const fetchGachaChances = async () => {
  // 只在應該顯示扭蛋圖標時才獲取抽獎次數
  if (!shouldShowGachaIcon.value) {
    gachaChances.value = 0;
    return;
  }

  try {
    console.log("user = ", user.student);

    let response;
    // 根據 VITE_MSU_DOMAIN 決定是否設定開始日期
    if (import.meta.env.VITE_MSU_DOMAIN === "app") {
      // 不限開始時間
      response = await ApiPrize.getStudentProgressAndPrizes(user.student.stuID);
    } else {
      // 設定開始時間為 2025-06-01
      response = await ApiPrize.getStudentProgressAndPrizes(
        user.student.stuID,
        "2025-06-01"
      );
    }

    if (response.status === "success") {
      gachaChances.value = response.record.remaining_chances;
    }
  } catch (error) {
    console.error("获取抽奖次数失败:", error);
    gachaChances.value = 0;
  }
};

onMounted(() => {
  progressBar(user.student.exp, user.student.amt_exp);
  deviceType.value = getDetectObj();
  windowWidth.value = window.innerWidth;
  window.addEventListener("resize", () => {
    deviceType.value = getDetectObj();
    windowWidth.value = window.innerWidth;
  });

  // 添加此行来获取抽奖次数
  fetchGachaChances();
});
</script>
<style lang="scss" scoped>
.profile-text {
  background-color: #f5f5f5;
}
.card-body {
  padding: 1rem;
}

.gift-wrap2 {
  margin: 0 0.5rem 0 0;
  // background-color: #feeac6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 1rem;
  background-color: #32c1db;
  color: #ffffff;
}
.gift-wrap2:hover {
  background-color: #ffce67;
  color: #617182;
}
// .gift-wrap2:hover {
//   transform: scale(1.06);
// }

.icon-square {
  position: relative;
  border-radius: 16px;
}

.gift-text m-text msu-semibold2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.img-avatar-frame {
  background-image: url("../assets/img/images/user-award@2x.png");
  background-size: cover;
  width: 178px;
  height: 120px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile {
  z-index: 1;
}

.activity-btn-img {
  width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.activity-btn-img:hover {
  transform: scale(1.05);
}

.icon-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.activity-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  background-color: #fafafa;
}

.activity-section h6 {
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
}
.activity-title-color {
  color: #828282;
}
</style>
